import { getClient } from "services";
import errorHandler from "services/statsService/errorHandler";

import SessionReport from "seneca-common/features/session/models/SessionReport";
import logError from "seneca-common/utils/sentry/logError";

import {
  fetchAllCourseStatsActionFactory,
  fetchContentStatsActionFactory,
  fetchCourseStatActionFactory,
  fetchSectionStatActionFactory,
  fetchUserStatActionFactory,
  receiveAllUserCoursesStats,
  receiveContentStudyStats,
  receiveCourseStudyStats,
  receiveSectionStudyStats,
  receiveUserStudyStats
} from "../state";

const getStatServiceClient = () => getClient("statsService");

export async function sendSessionReport(sessionReport: SessionReport) {
  try {
    return await getClient("statsService").emitSession(sessionReport.toJS());
  } catch (error: any) {
    logError(error, {
      message: "Error sending session report:"
    });
    throw error;
  }
}

// User
export const fetchUserStudyStats = fetchUserStatActionFactory({
  requestFunction: () => getStatServiceClient().fetchUserStats(),
  storeAction: receiveUserStudyStats,
  errorHandler
});

// All courses
export const fetchAllCourseStudyStats = fetchAllCourseStatsActionFactory({
  requestFunction: options =>
    getStatServiceClient().fetchAllCourseStatsForUser(options),
  storeAction: receiveAllUserCoursesStats,
  errorHandler
});

// Course
const fetchCourseStudyStatsAction = fetchCourseStatActionFactory({
  requestFunction: (ids: any) =>
    getStatServiceClient().fetchUserCoursesStats(ids),
  storeAction: receiveCourseStudyStats,
  errorHandler
});

export function fetchCourseStudyStats(courseId: string) {
  return fetchCourseStudyStatsAction([[courseId]], courseId);
}

// Sections
const fetchSectionStudyStatsForCourse = fetchSectionStatActionFactory({
  requestFunction: (courseId, options) =>
    getStatServiceClient().fetchCourseSectionStatsForUser(courseId, options),
  storeAction: receiveSectionStudyStats,
  errorHandler
});

export function fetchSectionStudyStats(courseId: string) {
  return fetchSectionStudyStatsForCourse(courseId, courseId);
}

// Contents
const fetchContentStudyStatsAction = fetchContentStatsActionFactory({
  requestFunction: (courseId, options) =>
    getStatServiceClient().fetchCourseContentStatsForUser(courseId, options),
  storeAction: receiveContentStudyStats,
  errorHandler
});

export function fetchContentStudyStats(courseId: string) {
  return fetchContentStudyStatsAction(courseId, courseId);
}
